import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Outlet } from 'react-router-dom'
import { Menu } from 'lucide-react'
import Sidebar from '../components/layout/Sidebar'
import AdminChatWidget from '@/components/chat/AdminChatWidget'
import Header from '../components/layout/Header'
import { useTranslation } from 'react-i18next'

interface AdminLayoutProps {
  children?: React.ReactNode
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const { t } = useTranslation('common')
  const [sidebarOpen, setSidebarOpen] = useState(false) // 모바일에서는 기본적으로 닫힘

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen)

  return (
    <div className="flex bg-dark-950 h-screen overflow-hidden">
      {/* Desktop Sidebar - Fixed */}
      <div className="hidden lg:block w-52 relative z-40 flex-shrink-0">
        <Sidebar isOpen={true} onClose={() => {}} />
      </div>

      {/* Mobile Sidebar - Overlay */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ x: -208 }}
            animate={{ x: 0 }}
            exit={{ x: -208 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="fixed top-[56px] bottom-0 left-0 w-52 z-[55] lg:hidden"
          >
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Mobile backdrop */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black/90 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
      </AnimatePresence>

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-0 min-w-0">
        {/* Header - Always shown */}
        <Header onMenuClick={toggleSidebar} />

        {/* Main content - Scrollable.
            pb-24: 모바일에서 플로팅 채팅 FAB(우하단)가 페이지 하단 버튼을 가리지 않도록 스크롤 여백 확보 (2026-09-03). */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden min-w-0 pb-24 lg:pb-0">
          {children || <Outlet />}
        </main>
      </div>

      {/* 플로팅 실시간 채팅 위젯 (2026-07-29 사장님) — 전 관리자 페이지 */}
      <AdminChatWidget />
    </div>
  )
}

export default AdminLayout